module.exports = __webpack_public_path__ + "static/img/Cladding_Cedar_Slatted.f3b616c.jpg";